import React, { useState } from 'react';
import PropTypes from 'prop-types';

import './styles.css';

const RemoveButton = props => {
  const {
    disabled,
    controlFunc,
    customStyles,
    btnBg = '#fff',
    btnHoverBg = '#f40',
    type = 'button',
  } = props;

  const [hover, setHover] = useState(false);

  const hoverOn = () => {
    setHover(true);
  };

  const hoverOff = () => {
    setHover(false);
  };

  const btnStyles = {
    backgroundColor: hover ? btnHoverBg : btnBg,
    ...customStyles,
  };

  return (
    <button
      type={type}
      disabled={disabled}
      className={
        hover
          ? `remove-button remove-button--hovered`
          : `remove-button remove-button`
      }
      onClick={controlFunc}
      onMouseEnter={hoverOn}
      onMouseLeave={hoverOff}
      onFocus={hoverOn}
      onBlur={hoverOff}
      style={btnStyles}
    />
  );
};

RemoveButton.propTypes = {
  controlFunc: PropTypes.func.isRequired,
  customStyles: PropTypes.object,
  btnHoverBg: PropTypes.string,
  btnBg: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
};

export default RemoveButton;
